import { ActionStepData } from './step-data'

export enum WorkflowStepType {
  BUGLE = 'BUGLE',
  FORWARD_FILL = 'FORWARD_FILL',
  WAIT_DURATION = 'WAIT_DURATION',
  EDIT_SHIFT_CONSTRAINTS = 'EDIT_SHIFT_CONSTRAINTS',
  SLACK = 'SLACK',
  SHIFT_INVITATIONS = 'SHIFT_INVITATIONS',
  SHIFT_AUTO_FILL = 'SHIFT_AUTO_FILL',
  SHIFT_AUTO_FILL_STOP_SESSIONS = 'SHIFT_AUTO_FILL_STOP_SESSIONS',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  PRE_SHIFT_CONFIRMATION = 'PRE_SHIFT_CONFIRMATION',
  ROBOCALL = 'ROBOCALL',
  EMAIL = 'EMAIL',
  LATE_CANCELLATION_CHECKPOINT = 'LATE_CANCELLATION_CHECKPOINT',
  AI_CONVERSATIONAL_SMS = 'AI_CONVERSATIONAL_SMS',
  WAIT_CALENDAR_TIME = 'WAIT_CALENDAR_TIME',
  METABLOCK = 'METABLOCK',
}

export const DSF_SUPPORTED_WORKFLOW_STEP_TYPES = [
  WorkflowStepType.BUGLE,
  WorkflowStepType.FORWARD_FILL,
  WorkflowStepType.WAIT_DURATION,
  WorkflowStepType.EDIT_SHIFT_CONSTRAINTS,
  WorkflowStepType.SHIFT_INVITATIONS,
  WorkflowStepType.SHIFT_AUTO_FILL,
  WorkflowStepType.SHIFT_AUTO_FILL_STOP_SESSIONS,
  WorkflowStepType.ANNOUNCEMENT,
  WorkflowStepType.WAIT_CALENDAR_TIME,
  WorkflowStepType.METABLOCK,
]

export const SHIFT_READINESS_SUPPORTED_WORKFLOW_STEP_TYPES = [
  WorkflowStepType.WAIT_DURATION,
  WorkflowStepType.WAIT_CALENDAR_TIME,
  WorkflowStepType.SLACK,
  WorkflowStepType.PRE_SHIFT_CONFIRMATION,
  WorkflowStepType.ROBOCALL,
  WorkflowStepType.EMAIL,
  WorkflowStepType.LATE_CANCELLATION_CHECKPOINT,
  WorkflowStepType.ANNOUNCEMENT,
  WorkflowStepType.AI_CONVERSATIONAL_SMS,
]

export enum WorkflowStepStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED',
}

export const WorkflowStepTypeLabels: Record<WorkflowStepType, string> = {
  [WorkflowStepType.BUGLE]: 'Send Bugle Notification',
  [WorkflowStepType.FORWARD_FILL]: 'Restart Forward Fill',
  [WorkflowStepType.WAIT_DURATION]: 'Wait for Duration',
  [WorkflowStepType.EDIT_SHIFT_CONSTRAINTS]: 'Edit Shift Constraints',
  [WorkflowStepType.SLACK]: 'Send Slack Message',
  [WorkflowStepType.SHIFT_INVITATIONS]: 'Send Shift Invitations',
  [WorkflowStepType.SHIFT_AUTO_FILL]: 'Start Shift Auto Fill',
  [WorkflowStepType.SHIFT_AUTO_FILL_STOP_SESSIONS]: 'Stop Shift Auto Fill',
  [WorkflowStepType.ANNOUNCEMENT]: 'Send Announcement',
  [WorkflowStepType.PRE_SHIFT_CONFIRMATION]: 'Pre-shift confirmation',
  [WorkflowStepType.ROBOCALL]: 'Robocall',
  [WorkflowStepType.EMAIL]: 'Email',
  [WorkflowStepType.LATE_CANCELLATION_CHECKPOINT]:
    'Late Cancellation Checkpoint',
  [WorkflowStepType.AI_CONVERSATIONAL_SMS]: 'AI Conversational SMS',
  [WorkflowStepType.WAIT_CALENDAR_TIME]: 'Wait Until Calendar Time',
  [WorkflowStepType.METABLOCK]: 'METABLOCK Dynamic Shift Filling',
}

/**
 * Converts a WorkflowStepType enum value to a human-readable label
 * @param stepType - The workflow step type enum value
 * @returns Human-readable label for the step type
 */
export function getWorkflowStepLabel(stepType: WorkflowStepType): string {
  return WorkflowStepTypeLabels[stepType] || stepType
}

export type WorkflowTemplateStep = ActionStepData & { id: string }

export type WorkflowStep = WorkflowTemplateStep & {
  status: WorkflowStepStatus
  startedAt: Date | undefined
  endedAt: Date | undefined
  /** Whether this step was dynamically generated by a METABLOCK execution */
  isFromMetablock?: boolean
  /** Cycle number this step belongs to (0-indexed). Set for steps generated by METABLOCK. */
  metablockCycleCount?: number
}
